var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 765.08 817.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fec829;}.cls-3{fill:#244c9b;}.cls-4{fill:#e73b2c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 765.08,
    height: 817.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M429.86,790.94A12.35,12.35,0,0,0,442.53,803a12.49,12.49,0,0,0,12.62-12.25,12.66,12.66,0,0,0-25.29.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.78,751.1a12.66,12.66,0,1,0,12.62-12.23,12.35,12.35,0,0,0-12.62,12.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M465.79,710.55a12.66,12.66,0,1,0,12.62-12.22,12.35,12.35,0,0,0-12.62,12.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M521.36,641.71A10.56,10.56,0,0,0,532.19,652,10.67,10.67,0,0,0,543,641.56a10.52,10.52,0,0,0-10.82-10.3,10.66,10.66,0,0,0-10.79,10.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M555.5,611.9a9.4,9.4,0,0,0,9.64,9.2,9.27,9.27,0,1,0-9.64-9.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M596.13,584.32a8.78,8.78,0,0,0,9,8.59,8.88,8.88,0,0,0,9-8.71,9,9,0,0,0-18,.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M637.51,565.13a6.59,6.59,0,0,0,6.76,6.45A6.66,6.66,0,0,0,651,565a6.57,6.57,0,0,0-6.76-6.44,6.66,6.66,0,0,0-6.74,6.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M675.45,552.89a4.62,4.62,0,1,0,4.61-4.48,4.56,4.56,0,0,0-4.61,4.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M492.32,673.6a10.54,10.54,0,0,0,10.82,10.32,10.65,10.65,0,0,0,10.78-10.47,10.53,10.53,0,0,0-10.82-10.3,10.66,10.66,0,0,0-10.78,10.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M580.58,630.66a11.52,11.52,0,0,0,1.25,16.3,11.65,11.65,0,0,0,16.4-.63,11.81,11.81,0,0,0-17.65-15.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M550.69,656.35a12.39,12.39,0,1,0,17.18-.64,12.09,12.09,0,0,0-17.18.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M521.54,687.9a12.39,12.39,0,1,0,17.18-.64,12.09,12.09,0,0,0-17.18.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M499.06,724.79a12.38,12.38,0,1,0,17.18-.64,12.1,12.1,0,0,0-17.18.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M481.21,759.68a12.38,12.38,0,1,0,17.18-.64,12.1,12.1,0,0,0-17.18.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M468.85,797.32a12.38,12.38,0,1,0,17.18-.64,12.09,12.09,0,0,0-17.18.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M614.63,608.85a11.52,11.52,0,0,0,1.25,16.29,11.66,11.66,0,0,0,16.41-.62,11.81,11.81,0,0,0-17.66-15.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M650.09,589.66A11.52,11.52,0,0,0,651.34,606a11.65,11.65,0,0,0,16.4-.62,11.81,11.81,0,0,0-17.65-15.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M690.3,577.62a11.52,11.52,0,0,0,1.26,16.3,11.65,11.65,0,0,0,16.4-.63A11.52,11.52,0,0,0,706.69,577a11.65,11.65,0,0,0-16.39.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M731.94,570.21a10.1,10.1,0,1,0,14-.52,9.86,9.86,0,0,0-14,.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M587.93,679.81A10.25,10.25,0,1,0,602.05,678a10,10,0,0,0-14.12,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M565,704.14a10.47,10.47,0,0,0,2.43,14.67A10.34,10.34,0,1,0,565,704.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M543.09,731.62a10.75,10.75,0,1,0,14.81-1.86,10.5,10.5,0,0,0-14.81,1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M524.82,764a10.5,10.5,0,0,0,2.43,14.69,10.62,10.62,0,0,0,14.83-1.88A10.76,10.76,0,0,0,524.82,764"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M512,795.57a10.75,10.75,0,1,0,14.81-1.86A10.5,10.5,0,0,0,512,795.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M617.64,656.92a10.25,10.25,0,1,0,14.12-1.78,10,10,0,0,0-14.12,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M646.72,638.38a10.26,10.26,0,1,0,14.14-1.77,10.12,10.12,0,0,0-14.14,1.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M680.28,624.47a10.26,10.26,0,1,0,14.14-1.77,10.12,10.12,0,0,0-14.14,1.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M749.34,610.25a8.54,8.54,0,0,0,2,12,8.65,8.65,0,0,0,12.08-1.53,8.76,8.76,0,0,0-14.06-10.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M714.45,616a8.54,8.54,0,0,0,2,12,8.65,8.65,0,0,0,12.08-1.52A8.76,8.76,0,0,0,714.45,616"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDow);
export default __webpack_public_path__ + "static/media/dow.7a4ddf55ea48192bb1078a4d635116bc.svg";
export { ForwardRef as ReactComponent };